import React, { useState } from 'react';

function App() {
  const [formData, setFormData] = useState({ nombre: '', telefono: '', servicio: 'Limpieza' });
  const [mensaje, setMensaje] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.nombre || !formData.telefono) {
      setMensaje('❌ Por favor, ingresa tu nombre y teléfono.');
      return;
    }
    setMensaje(`¡Gracias, ${formData.nombre}! El equipo del Dr. Eddy Vega se comunicará contigo a la brevedad para confirmar tu cita.`);
    setFormData({ nombre: '', telefono: '', servicio: 'Limpieza' });
  };

  const servicios = [
    { icon: '🪥', title: 'Limpiezas Profesionales', desc: 'Limpiezas con ultrasonido, pulido dental y revisión completa para mantener tu sonrisa sana y brillante.' },
    { icon: '🦷', title: 'Ortodoncia Moderna', desc: 'Alineación dental con brackets estéticos y placas transparentes para un tratamiento cómodo y eficaz.' },
    { icon: '✨', title: 'Blanqueamiento Dental', desc: 'Resultados visibles con protocolos seguros que eliminan manchas y aclaran tu sonrisa hasta varios tonos.' },
    { icon: '🛠️', title: 'Endodoncia y Restauración', desc: 'Tratamiento de conductos y restauraciones conservadoras para salvar piezas dentales con precisión.' },
    { icon: '🪡', title: 'Implantes Dentales', desc: 'Reemplazo permanente y funcional de piezas dentales con prótesis personalizadas y alta estabilidad.' },
    { icon: '🩺', title: 'Revisiones Preventivas', desc: 'Chequeos periódicos, diagnóstico temprano y planes personalizados para cuidar tu salud bucal.' }
  ];

  const faqs = [
    { question: '¿Qué métodos de pago aceptan?', answer: 'Aceptamos efectivo, tarjetas de débito y crédito, transferencias bancarias y pagos en línea mediante plataformas seguras.' },
    { question: '¿Cómo debo prepararme antes del tratamiento?', answer: 'Llega con buena hidratación, informa sobre medicamentos que tomas y trae tu historial médico dental si lo tienes.' },
    { question: '¿Qué cuidados seguir después de una limpieza o blanqueamiento?', answer: 'Evita alimentos muy pigmentados las primeras 24 horas, mantén una higiene suave y sigue las recomendaciones de tu odontólogo.' },
    { question: '¿Pueden atender urgencias dentales?', answer: 'Sí, manejamos urgencias con atención prioritaria para dolor, inflamación o pérdida dental durante horario de consultorio.' }
  ];


  return (
    <div className="app-root">
      <header className="site-header">
        <div className="header-inner">
          <div className="brand">
            <img src="/flaticon.png" alt="ClinicDent logo" className="brand-logo" />
            <div>
              <strong>ClinicDent</strong>
              <div className="brand-subtitle">Dr. Eddy Vega de la Paz</div>
            </div>
          </div>

          <nav className="nav-links">
            <a href="#catalogo">Servicios</a>
            <a href="#faq">FAQ</a>
            <a href="#contacto" className="cta-link">Agendar Cita</a>
          </nav>
        </div>
      </header>

      <main>
        <section className="hero-section">
          <div className="hero-copy">
            <h1>Diseñamos tu Sonrisa con Tecnología y Cuidado Profesional</h1>
            <p>El Dr. Eddy Vega de la Paz ofrece atención odontológica integral con la mayor comodidad y los más altos estándares de higiene.</p>
            <a href="#contacto" className="hero-button">Agendar Consulta Evaluativa</a>
          </div>
        </section>

        <section id="catalogo" className="section-block">
          <div className="section-title">
            <h2>Catálogo de Servicios y Tratamientos</h2>
            <p>Presentamos procedimientos con iconos y descripciones claras para que elijas con confianza.</p>
          </div>
          <div className="cards-grid">
            {servicios.map((item, index) => (
              <details key={index} className="service-card">
                <summary>
                  <div className="service-title">
                    <span className="service-icon">{item.icon}</span>
                    <span>{item.title}</span>
                  </div>
                </summary>
                <p>{item.desc}</p>
              </details>
            ))}
          </div>
        </section>

        <section id="faq" className="section-block section-light">
          <div className="section-title">
            <h2>Preguntas Frecuentes (FAQ)</h2>
            <p>Resolvemos las dudas más comunes sobre métodos de pago, recomendaciones y horarios.</p>
          </div>
          <div className="faq-grid">
            {faqs.map((item, index) => (
              <details key={index} className="faq-item">
                <summary>{item.question}</summary>
                <p>{item.answer}</p>
              </details>
            ))}
          </div>
        </section>

        <section id="horarios" className="section-block section-light">
          <div className="section-grid">
            <div className="info-panel">
              <h2>Horarios del Consultorio</h2>
              <div className="schedule-card">
                <div className="schedule-row">
                  <strong>Lunes a Sábado:</strong>
                  <span>10:00 AM - 07:00 PM</span>
                </div>
                <div className="schedule-row">
                  <strong>Domingos:</strong>
                  <span className="note-red">Previo Acuerdo</span>
                </div>
              </div>
              <h3>Contacto Directo</h3>
              <p>📞 Tel: 618-839-2331</p>
              <p>✉️ contacto@clinicdent.com</p>
            </div>

            <div id="contacto" className="contact-panel">
              <h2>Solicitar Cita Médica</h2>
              <form onSubmit={handleSubmit} className="contact-form">
                <input type="text" placeholder="Tu Nombre Completo" value={formData.nombre} onChange={(e) => setFormData({ ...formData, nombre: e.target.value })} />
                <input type="text" placeholder="Número de Teléfono" value={formData.telefono} onChange={(e) => setFormData({ ...formData, telefono: e.target.value })} />
                <select value={formData.servicio} onChange={(e) => setFormData({ ...formData, servicio: e.target.value })}>
                  <option value="Limpieza">Limpieza Dental</option>
                  <option value="Ortodoncia">Ortodoncia</option>
                  <option value="Blanqueamiento">Blanqueamiento</option>
                  <option value="Endodoncia">Endodoncia</option>
                  <option value="Implantes">Implantes</option>
                </select>
                <button type="submit">Enviar Registro</button>
              </form>
              {mensaje && <div className="message-box">{mensaje}</div>}
            </div>
          </div>
        </section>
      </main>

      <footer className="site-footer">
        <p>© 2026 ClinicDent - Dr. Eddy Vega de la Paz. Todos los derechos reservados.</p>
        <p className="footer-note">Despliegue final exitoso por Axel Javier Sandoval Sanchez en AWS EC2.</p>
      </footer>
    </div>
  );
}

export default App;
